import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseListDomainService } from '@common/domain/base-list-domain.service';
import { ResultDomain } from '@common/domain/result-domain';
import { ResultApi } from '@common/api/result-api';
import { VeeamJobApi } from '@apps/bckp/api/models/veeamJob-api';
import { VeeamJob } from '../../models/veeamJob';
import { VbrJobListApiService } from '@apps/bckp/api/veeam/vbr/vbr-job-list-api.service';

@Injectable({
    providedIn: 'root'
})
export class VbrJobListDomainService extends BaseListDomainService
{
    constructor (
        private jobListApiService: VbrJobListApiService
    )
    {
        super();
    }

    getAll (qs: string): Observable<ResultDomain<VeeamJob>>
    {
        return this.jobListApiService.getJobs(qs)
            .pipe(
                map((resultApi: ResultApi<VeeamJobApi>) =>
                {
                    const resultDomain = new ResultDomain<VeeamJob>();

                    resultDomain.count = resultApi['@odata.count'];
                    resultDomain.value = resultApi.value.map<VeeamJob>((jobApi: VeeamJobApi) =>
                        VeeamJob.mapperFromApi(jobApi)
                    );

                    return resultDomain;
                })
            );
    }
}
